<template>
    <div>
        <div class="section">
            <div class="columns">
                <div class="column">
                    <div class="field">
                        <label class="label has-text-left">Book filter</label>
                        <div class="control">
                            <div class="select">
                                <select v-on:change="setFilters()" v-model="bookFilter">
                                    <option value="All">All</option>
                                    <option v-for="(book) in books" :key="book" :value="book">{{bookName(book)}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="field">
                        <label class="label has-text-left">User filter</label>
                        <div class="control">
                            <div class="select">
                                <select v-on:change="setFilters()" v-model="userFilter">
                                    <option value="All">All</option>
                                    <option v-for="(user) in users" :key="user">{{user}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <canvas id="chart"></canvas>
        </div>
    </div>
</template>

<script>
import {config} from '../mixins/config.js';
import $ from "jquery";
import Chart from 'chart.js';
import '../styles.scss';
export default {
    name: 'Chart',
    data () {
        return {
            chartData: {
                type: 'line',
                data: {
                    labels: [],
                    datasets: [
                        {
                            label: 'Discussion responses',
                            data: [],
                            backgroundColor: 'rgba(54,73,93,.5)',
                            fill: false
                        }
                    ]
                },
                options: {
                    responsive: true,
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                padding: 25
                            }
                        }]
                    },
                    legend: {
                        position: 'bottom',
                        align: 'start',
                        fullWidth: true
                    },
                    pan: {
                        enabled: true,
                        mode: 'x',
                    },
                    zoom: {
                        enabled: true,
                        mode: 'x',
                        speed: 0.05
                    }
                    // onClick: this.discussionBarClick
                }
            },
            dateLabels: [],
            books: [],
            bookFilter: "All",
            users: [],
            userFilter: "All",
            discussionStatements: [],
            discussionChart: null
        }
    },
    methods: {
        bookName(filename) {
            if (filename === 'epub3-mgig.epub')
                return 'Making Good Instructors Great';
            else if (filename === 'MCDP_USMC_Book.epub')
                return 'MCDP 7';
            else
                return filename;
        },
        setFilters() {
            this.filterDiscussionStatements(this.bookFilter === "All" ? undefined : this.bookFilter, this.userFilter === "All" ? undefined : this.userFilter);
        },
        createChart(chartId, chartData) {
            var ctx = document.getElementById(chartId);
            this.discussionChart = new Chart(ctx, {
                type: chartData.type,
                data: chartData.data,
                options: chartData.options
            });
        },
        getStatements(pipeline, callback) {
            var urlString = config.lrsUrl;
            urlString = urlString + "api/statements/aggregate?pipeline=" + encodeURIComponent(JSON.stringify(pipeline));

            $.ajax({
                type: "GET",
                url: urlString,
                dataType: "json",
                async: true,
                headers: {
                    "Authorization": "Basic " + config.lrsCredential,
                    "X-Experience-API-Version": "1.0.3"
                },
                success: function (response) {
                    callback(response)
                },
                error: function() {
                    callback([]);
                }
            })
        },
        getAllDiscussions(callback) {
            let pipeline = [
                {
                    "$match": {
                        "$or": [
                            {
                                "statement.verb.id": "http://adlnet.gov/expapi/verbs/responded"
                            }
                        ]
                    }
                }
            ];

            this.getStatements(pipeline, function(stmts) {
                callback(stmts);
            });
        },
        discussionBarClick(event, array) {
            if (array[0]._view.datasetLabel === "Discussion responses") {
                this.discussionDrilldownUser(array[0]._view.label);
            }
        },
        discussionDrilldownUser(user) {
            var userDiscussions = this.userData[user].discussions;
            var label = "Discussion threads for " + user;
            var threads = [];
            var countsPerThread = [];
            for (let stmts of Object.values(userDiscussions)) {
                if (stmts[0].object.definition.name['en-US'] !== 'DataEntry') {
                    threads.push(stmts[0].object.definition.name['en-US']);
                } else {
                    let arr = JSON.parse(stmts[0].object.definition.description['en-US']);
                    for (let dataEntry of arr) {
                        threads.push(dataEntry.prompt);
                    }
                }
                
                countsPerThread.push(stmts.length);
            }
            this.discussionChart.data.labels = threads;
            this.discussionChart.data.datasets[0].data = countsPerThread;
            this.discussionChart.data.datasets[0].label = label;
            this.discussionChart.update();

            //             var dates = {};
            // for (let statement of stmts) {
            //     let stmt = statement.statement;
            //     var localDate = new Date(stmt.timestamp);
            //     var dateString = 
            //     if (!self.userData[stmt.actor.name])
            //         self.userData[stmt.actor.name] = {
            //             discussions: {}
            //         }

            //     if (!self.userData[stmt.actor.name].discussions[stmt.object.id])
            //         self.userData[stmt.actor.name].discussions[stmt.object.id] = [];

            //     self.userData[stmt.actor.name].discussions[stmt.object.id].push(stmt);

            // }

            // if (self.discussionChart) {
            //     self.discussionChart.data.labels = Object.keys(self.userData);

            //     var countsPerUser = [];
            //     for (let user of Object.values(self.userData)) {
            //         let count = 0;
            //         for (let discussions of Object.values(user.discussions)) {
            //             count += discussions.length;
            //         }
            //         countsPerUser.push(count);
            //     }
            //     self.discussionChart.data.datasets[0].data = countsPerUser;
            //     self.discussionChart.update();
            // }
        },
        dateToMDY(date) {
            let dateString = (date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear();
            return dateString;
        },
        dynamicColors() {
            var r = Math.floor(Math.random() * 255);
            var g = Math.floor(Math.random() * 255);
            var b = Math.floor(Math.random() * 255);
            return "rgb(" + r + "," + g + "," + b + ")";
        },
        filterDiscussionStatements(book, user) {
            var self = this;
            var filteredStatements = this.discussionStatements.filter(function(x) {
                let remove = false;
                if (book && x.statement.context.contextActivities.parent[0].id !== 'pebl://' + book)
                    remove = true;
                if (user && x.statement.actor.name !== user)
                    remove = true;

                return !remove;
            });

            var threads = {}
            for (let stmt of filteredStatements) {
                let dateLabel = self.dateToMDY(new Date(stmt.timestamp));
                if (['DataEntry', 'DataEntryOfficial', 'PrivateDataEntry'].includes(stmt.statement.object.definition.name['en-US'])) {
                    let arr = JSON.parse(stmt.statement.object.definition.description['en-US']);
                    for (let x of arr) {
                        if (!threads[x.prompt])
                            threads[x.prompt] = {
                                prompt: x.prompt
                            };
                        if (!threads[x.prompt][dateLabel])
                            threads[x.prompt][dateLabel] = [];

                        threads[x.prompt][dateLabel].push({
                            user: stmt.statement.actor.name,
                            value: x.text,
                            prompt: x.prompt
                        });
                    }
                } else if (!['DataEntry', 'DataEntryOfficial', 'PrivateDataEntry'].includes(stmt.statement.object.definition.name['en-US'])) {
                    if (!threads[stmt.statement.object.definition.extensions['https://www.peblproject.com/definitions.html#masterThread']])
                        threads[stmt.statement.object.definition.extensions['https://www.peblproject.com/definitions.html#masterThread']] = {
                            prompt: stmt.statement.object.definition.name['en-US']
                        };
                    if (!threads[stmt.statement.object.definition.extensions['https://www.peblproject.com/definitions.html#masterThread']][dateLabel])
                        threads[stmt.statement.object.definition.extensions['https://www.peblproject.com/definitions.html#masterThread']][dateLabel] = [];

                    threads[stmt.statement.object.definition.extensions['https://www.peblproject.com/definitions.html#masterThread']][dateLabel].push({
                        user: stmt.statement.actor.name,
                        value: stmt.statement.object.definition.description['en-US'],
                        prompt: stmt.statement.object.definition.name['en-US']
                    });
                }
            }

            var datasets = [];

            for (let thread in threads) {
                let color = self.dynamicColors();
                let dataset = {
                    label: threads[thread].prompt,
                    data: [],
                    backgroundColor: color,
                    borderColor: color,
                    fill: false,
                    lineTension: 0
                }
                for (let dateLabel of self.dateLabels) {
                    if (threads[thread][dateLabel])
                        dataset.data.push(threads[thread][dateLabel].length);
                    else
                        dataset.data.push(0);
                }
                datasets.push(dataset);
            }

            self.discussionChart.data.labels = self.dateLabels;
            self.discussionChart.data.datasets = datasets;
            self.discussionChart.update();
        }
    },
    mounted() {
        var self = this;
        this.createChart('chart', this.chartData);
        this.getAllDiscussions(function(stmts) {
            self.users = Array.from(new Set(stmts.map(function(x) {
                return x.statement.actor.name;
            }))).sort();

            self.books = Array.from(new Set(stmts.map(function(x) {
                return x.statement.context.contextActivities.parent[0].id.replace('pebl://', '');
            })));

            self.discussionStatements = stmts.sort(function(x, y) {
                return new Date(x.timestamp) - new Date(y.timestamp);
            });

            self.dateLabels = Array.from(new Set(self.discussionStatements.map(function(x) {
                return self.dateToMDY(new Date(x.timestamp));
            })));            
            
            self.filterDiscussionStatements();
        });
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
